import { AnyAction, Reducer } from 'redux';

export const STORE_USERNAME = 'forgotLink/store-username';

export interface ForgotLinkState {
    userName?: string;
}

const initialState: ForgotLinkState = {
    userName: ''
};

const reducer: Reducer<ForgotLinkState> = (state: ForgotLinkState = initialState, action: AnyAction): ForgotLinkState => {
    switch (action.type) {
        case STORE_USERNAME:
            return {
                ...state,
                userName: action.userName
            };
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/forgotLink.tsx